import { render, staticRenderFns } from "./CreateBox.vue?vue&type=template&id=993620aa&scoped=true"
import script from "./CreateBox.vue?vue&type=script&lang=js"
export * from "./CreateBox.vue?vue&type=script&lang=js"
import style0 from "./CreateBox.vue?vue&type=style&index=0&id=993620aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993620aa",
  null
  
)

export default component.exports